import React from 'react';
import styled from '@emotion/styled';
import artePropTypes from '../../propTypes';

import { mediaQueries, remCalc, font } from '../../css';

const StyledWrapper = styled('div')(({ theme }) => ({
    padding: remCalc(20, 0),
    lineHeight: font.size.s,
    fontSize: font.size.xs,
    color: theme.global.textColor,
    opacity: 0.6,
    [mediaQueries.medium]: {
        fontSize: '1.1rem',
        textAlign: 'center',
    },
}));

export const LegacySection = ({ label }) => <StyledWrapper>{label}</StyledWrapper>;

LegacySection.propTypes = artePropTypes.legacyFooter.isRequired;

export default LegacySection;
